import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RecurrencyService } from 'app/services/recurrency/recurrency.service';

declare const swal: any;

@Component({
  selector: 'app-edit-recurrency',
  templateUrl: './edit-recurrency.component.html',
  styleUrls: ['./edit-recurrency.component.css']
})
export class EditRecurrencyComponent implements OnInit {

  days = [
    'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'
  ]

  constructor(
    private dialogRef: MatDialogRef<EditRecurrencyComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    private recurrencyService: RecurrencyService) { }

  ngOnInit(): void {
  }

  recurrencyForm = this.formBuilder.group({
    description: new FormControl(this.data.description, Validators.required),
    days: new FormControl(this.data.days, Validators.required)
  });

  cancel(){
    this.dialogRef.close();
  }

  saveRecurrency(){
    try {
      let recurrency = this.recurrencyForm.value;
      recurrency.enterprise = JSON.parse(sessionStorage.getItem('loggedUser')).databaseId;
      
      if(this.recurrencyForm.valid){
        this.recurrencyService.saveRecurrency(recurrency).subscribe(result => {
          this.dialogRef.close();
          this.openAlert(1);
          console.log('recurrency saved!');
        });        
      }else{
        this.openAlert(0);
      }


    } catch (error) {
      alert('Error guardando recurrencia: ' + error);
      console.error('Error guardando recurrencia: ', error);
    }
  }

  openAlert(type){
    switch (type) {
      case 1:
        swal({
          title: 'Guardado correctamente',
          text: 'Presiona OK para continuar',
          type: 'success',
          timer: 3000,
          showConfirmButton: false
        })
        break;
      case 0:
        swal({
          title: 'Atención',
          text: 'Debes llenar todos los campos requeridos',
          type: 'warning',
          confirmButtonClass: 'btn btn-danger'
        })
    }
  }

  

}
